import { cn } from "@/lib/utils";

/**
 * HUDFrame — adds subtle corner brackets to a container.
 * Purely decorative. Wrap any block.
 */
export default function HUDFrame({ children, className, tone = "teal" }) {
  const color =
    tone === "amber"
      ? "border-amber"
      : tone === "mist"
        ? "border-mist/40"
        : "border-teal/70";

  return (
    <div className={cn("relative", className)}>
      {/* corners */}
      <span
        className={cn(
          "pointer-events-none absolute -top-px -left-px h-3 w-3 border-t border-l",
          color
        )}
      />
      <span
        className={cn(
          "pointer-events-none absolute -top-px -right-px h-3 w-3 border-t border-r",
          color
        )}
      />
      <span
        className={cn(
          "pointer-events-none absolute -bottom-px -left-px h-3 w-3 border-b border-l",
          color
        )}
      />
      <span
        className={cn(
          "pointer-events-none absolute -bottom-px -right-px h-3 w-3 border-b border-r",
          color
        )}
      />
      {children}
    </div>
  );
}
